import { gql } from "@apollo/client";

export const CHANGE_STATE_PLANCUIDADO = gql`
    mutation ChangePlanCuidadoEstado(        
        $idPlanCuidado: Int!
        $state: PlanCuidadoState!
        $motivoRechazo: String
         ){
        changePlanCuidadoEstado(input: {
            idPlanCuidado : $idPlanCuidado,
            state : $state
            motivoRechazo: $motivoRechazo
        }
        ) {
            idPlanCuidado
        }
    }
`;